'use client'

import { useTranslations } from 'next-intl'
import { CalendarCheck } from 'lucide-react'

type Props = { onOpen: () => void; accentColor?: string }

/** Sección del microsite con el CTA "Reservar mesa". El gating (si el local
 *  tiene reservas activas) lo decide el padre; acá solo se dispara `onOpen`. */
export function ReservationSection({ onOpen, accentColor }: Props) {
  const t = useTranslations('public.microsite')
  const accent = accentColor ?? '#ea580c'
  return (
    <section className="py-12 px-4 max-w-5xl mx-auto text-center" style={{ background: 'var(--ms-surface)' }}>
      <p className="text-xs font-bold tracking-[0.2em] uppercase" style={{ color: accent }}>
        {t('reservationKicker')}
      </p>
      <h2 className="mt-2 text-2xl font-bold" style={{ color: 'var(--ms-text)' }}>
        {t('reservationTitle')}
      </h2>
      <p className="mt-1 text-sm" style={{ color: 'var(--ms-text)', opacity: 0.7 }}>
        {t('reservationSubtitle')}
      </p>
      <button
        type="button"
        onClick={onOpen}
        className="mt-6 inline-flex items-center gap-2 rounded-full px-6 py-3 text-base font-bold text-white transition hover:opacity-90"
        style={{ backgroundColor: accent }}
      >
        <CalendarCheck className="w-5 h-5" />
        {t('reservationCta')}
      </button>
    </section>
  )
}
